import Api from 'services/Api'
import { loadTrip } from 'store/queries/trip'
import { get } from 'lodash' 

function reset () {
  return {
    id: null,
    behavior_annotations: [],
    behavior_scores: {},
    distance: null,
    end: null,
    end_ts: null,
    occupant_role: null,
    start: null,
    start_ts: null,
    trajectory: {}
  }
}

const state = reset()

const actions = {
  loadTrip ({ state, commit }, { id, start }) {
    if (id !== state.id || start !== state.start) {
      commit('reset')
    }

    return loadTrip({ id, start })
      .then(res => {
        const trip = res.body.data.user.event_history[0]

        commit('id', id)
        commit('trip', trip)
      })
  }
}

const mutations = {
  reset(state) {
    Object.assign(state, reset())
  },

  trip (state, value) {
    Object.assign(state, value)
  },

  id (state, id) {
    state.id = id
  }
}

const getters = {
  waypoints: state => {
    return get(state, 'trajectory.waypoints', [])
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
